// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TrustedContacts-headerRow-Bcjuw {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 18px;
}

.TrustedContacts-pageTitle-sAmQ1 {
    font-size: 22px;
    font-weight: 700;
    color: #1F2733;
    margin: 0;
    font-family: 'Poppins', sans-serif;
}

.TrustedContacts-addBtn-9ifqe {
    width: auto;
    min-width: 150px;
}

.TrustedContacts-formCard-OnH32 {
    background: #fff;
    border: 1px solid #ECECEC;
    border-radius: 14px;
    padding: 22px;
    margin-bottom: 24px;
}

.TrustedContacts-formTitle-pTdnY {
    font-size: 18px;
    font-weight: 600;
    color: #1F2733;
    margin: 0 0 16px;
}

.TrustedContacts-fieldGroup-CQn8P {
    margin-bottom: 16px;
}

.TrustedContacts-formBtnGroup-ifJVd {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 12px;
    margin-top: 20px;
}

.TrustedContacts-cancelBtn-q22g4 {
    width: auto;
    min-width: 120px;
}

.TrustedContacts-addressList-PiBrV {
    list-style: none;
    padding: 0;
    margin: 0;
}

.TrustedContacts-addressItem-OB_gB {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    gap: 12px;
    padding: 18px;
    border: 1px solid #ECECEC;
    border-radius: 14px;
    margin-bottom: 14px;
    background: #fff;
}

.TrustedContacts-addressInfo-OcUgV {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 4px;
}

.TrustedContacts-addressName-Mk_Qe {
    font-size: 15px;
    font-weight: 600;
    color: #1F2733;
}

.TrustedContacts-addressText-Zc9H1 {
    font-size: 14px;
    color: #555;
}

.TrustedContacts-addressActions-TXhff {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 16px;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.TrustedContacts-linkBtn-fup0M {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    font-weight: 600;
    color: #1F2733;
}

.TrustedContacts-deleteLink-Z_dqd {
    color: #D32F2F;
}

.TrustedContacts-emptyText-Vi545 {
    color: #777;
    font-size: 15px;
    padding: 20px 0;
}
`, "",{"version":3,"sources":["webpack://./src/routes/trustedContacts/TrustedContacts.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;IACf,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,SAAS;IACT,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;AACnB","sourcesContent":[".headerRow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-bottom: 18px;\n}\n\n.pageTitle {\n    font-size: 22px;\n    font-weight: 700;\n    color: #1F2733;\n    margin: 0;\n    font-family: 'Poppins', sans-serif;\n}\n\n.addBtn {\n    width: auto;\n    min-width: 150px;\n}\n\n.formCard {\n    background: #fff;\n    border: 1px solid #ECECEC;\n    border-radius: 14px;\n    padding: 22px;\n    margin-bottom: 24px;\n}\n\n.formTitle {\n    font-size: 18px;\n    font-weight: 600;\n    color: #1F2733;\n    margin: 0 0 16px;\n}\n\n.fieldGroup {\n    margin-bottom: 16px;\n}\n\n.formBtnGroup {\n    display: flex;\n    gap: 12px;\n    margin-top: 20px;\n}\n\n.cancelBtn {\n    width: auto;\n    min-width: 120px;\n}\n\n.addressList {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.addressItem {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 12px;\n    padding: 18px;\n    border: 1px solid #ECECEC;\n    border-radius: 14px;\n    margin-bottom: 14px;\n    background: #fff;\n}\n\n.addressInfo {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.addressName {\n    font-size: 15px;\n    font-weight: 600;\n    color: #1F2733;\n}\n\n.addressText {\n    font-size: 14px;\n    color: #555;\n}\n\n.addressActions {\n    display: flex;\n    gap: 16px;\n    align-items: center;\n}\n\n.linkBtn {\n    background: none;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    font-weight: 600;\n    color: #1F2733;\n}\n\n.deleteLink {\n    color: #D32F2F;\n}\n\n.emptyText {\n    color: #777;\n    font-size: 15px;\n    padding: 20px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerRow": `TrustedContacts-headerRow-Bcjuw`,
	"pageTitle": `TrustedContacts-pageTitle-sAmQ1`,
	"addBtn": `TrustedContacts-addBtn-9ifqe`,
	"formCard": `TrustedContacts-formCard-OnH32`,
	"formTitle": `TrustedContacts-formTitle-pTdnY`,
	"fieldGroup": `TrustedContacts-fieldGroup-CQn8P`,
	"formBtnGroup": `TrustedContacts-formBtnGroup-ifJVd`,
	"cancelBtn": `TrustedContacts-cancelBtn-q22g4`,
	"addressList": `TrustedContacts-addressList-PiBrV`,
	"addressItem": `TrustedContacts-addressItem-OB_gB`,
	"addressInfo": `TrustedContacts-addressInfo-OcUgV`,
	"addressName": `TrustedContacts-addressName-Mk_Qe`,
	"addressText": `TrustedContacts-addressText-Zc9H1`,
	"addressActions": `TrustedContacts-addressActions-TXhff`,
	"linkBtn": `TrustedContacts-linkBtn-fup0M`,
	"deleteLink": `TrustedContacts-deleteLink-Z_dqd`,
	"emptyText": `TrustedContacts-emptyText-Vi545`
};
module.exports = ___CSS_LOADER_EXPORT___;
